export default __webpack_public_path__ + "static/media/url-black.a3daf6da.svg";